var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconFlagLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconFlag",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1848.715 357.685c-13.891-15.586-35.35-22.137-55.793-17.167-419.802 105.035-630.324-19.087-833.844-139.03C756.46 82.333 547.52-40.66 168.94 103.905V0H56v1920h112.941V227.012c352.941-148.97 522.127-52.292 732.763 71.83 195.84 115.313 415.849 245.083 811.82 174.156-170.88 375.53-385.92 382.87-652.912 392.131-233.788 8.02-498.748 17.28-762.24 280.772l79.85 79.963c232.093-232.095 463.058-240 686.343-247.906 290.823-10.052 591.473-20.443 794.88-562.786 7.34-19.652 3.275-41.788-10.73-57.487",
      fillRule: "evenodd"
    })));
  }
}
IconFlagLine.glyphName = 'flag';
IconFlagLine.variant = 'Line';
IconFlagLine.displayName = 'IconFlagLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconFlagLine.propTypes = {
  ...SVGIcon.propTypes
};
IconFlagLine.allowedProps = [...SVGIcon.allowedProps];
export default IconFlagLine;
export { IconFlagLine };